module.exports = __webpack_public_path__ + "static/tech-dfe597092fa77c19328f1906970811ce.mp4";